import Page from "../../../common/components/layout/layout-components/page";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Resources from "../../../data/services/resources";
import {COMPANIES_SETTINGS_INCLUDED_LOOKUPS, READ_PERM, REQUIRED_DOCUMENTS_TYPES} from "../../../util/util-constants";
import PageHeader from "../../../common/components/layout/layout-components/page/page-header";
import PageHeaderInfo from "../../../common/components/layout/layout-components/page/page-header-info";
import Layout from "../../../common/components/layout";
import NavResponsive from "../../../common/components/nav-responsive";
import DocumentEntitiesTab from "../../../common/components/tabs/document-entities-tab";
import DocumentTypesTab from "../../../common/components/tabs/document-types-tab";
import Lookups from "../../../common/components/tabs/lookupTab";
import {checkPerm} from "../../../common/util/util-helpers";
import ModalConfirm from "../../../common/components/modal/modal-confirm";
import FleetSettingsGeneralTab from "../../fleet/fleet-settings-view/fleet-settings-tab";
import CompaniesSettingsGeneralTab from "./general-settings";
import CustomerChecklistTemplateTab from "./customer-checklist-template-tab";

export default function CompaniesSettingsView({translate, match, history, location}) {
    const dispatch = useDispatch();
    const ui = useSelector((state) => state.ui);
    const user = useSelector((state) => state.user);
    const resource = useSelector((state) => state.resource);

    const [tabs, setTabs] = useState(getTabs());
    const currentTab = tabs.find(tab => tab.current);

    const [breakpoint, setBreakpoint] = useState({})

    const [isTabDirty, setIsTabDirty] = useState(false);
    const [isDirtyStateWarningModalOpen, setIsDirtyStateWarningModalOpen] = useState(false);
    const [tabClicked, setTabClicked] = useState("");

    const handleTabChange = (resource) => {
        if (currentTab.resource === resource) {
            return false;
        }

        if (isTabDirty) {
            setIsDirtyStateWarningModalOpen(true);
            setTabClicked(resource)
        } else {
            setTabs(
                tabs.map((it) => {
                    it.current = it.resource === resource;
                    return it
                })
            )
        }
    }

    const handleBreakpointChange = (breakpoint) => {
        setBreakpoint(breakpoint)
    }

    return (
        <Layout
            ui={ui}
            user={user}
            match={match}
            history={history}
            location={location}
            translate={translate}
            dispatch={dispatch}
            isDirty={isTabDirty}
            hasFooter={currentTab.name === 'RequiredDocuments'}
            onBreakpointChange={handleBreakpointChange}
        >
            <Page>
                <PageHeader
                    title={translate('page.heading.CompaniesSettings')}
                    afterTitle={(
                        <PageHeaderInfo
                            dispatch={dispatch}
                        />
                    )}
                />

                <NavResponsive
                    tabs={tabs}
                    onTabChange={handleTabChange}
                    translate={translate}
                />

                {currentTab.name === 'GeneralSettings' && (
                    <CompaniesSettingsGeneralTab
                        translate={translate}
                        setIsTabDirty={setIsTabDirty}
                        resourcePath={currentTab.resource}
                    />
                )}

                {currentTab.name === 'customFields' && (
                    <Lookups
                        customLookupFilter={(item, name) => {
                            if (name === "DocumentType") {
                                return !!item.IsCompanyDocument
                            }
                            return true
                        }}
                        includeLookups={COMPANIES_SETTINGS_INCLUDED_LOOKUPS}
                        translate={translate}
                        resource={resource}
                        dispatch={dispatch}
                    />
                )}

                {currentTab.name === "DocumentTypes" && (
                    <DocumentTypesTab
                        translate={translate}
                        primaryType={'IsCompanyDocument'}
                        breakpoint={breakpoint}
                    />
                )}

                {currentTab.name === "RequiredDocuments" && (
                    <DocumentEntitiesTab
                        requiredTypes = {REQUIRED_DOCUMENTS_TYPES.Company}
                        translate={translate}
                        resource={resource}
                        dispatch={dispatch}
                        setIsTabDirty={setIsTabDirty}
                        sortOrder={['Customer','Carrier','Vendor']}
                    />
                )}

                {currentTab.name === 'ChecklistTemplate' && (
                    <CustomerChecklistTemplateTab
                        translate={translate}
                        resource={resource}
                        dispatch={dispatch}
                        setIsTabDirty={setIsTabDirty}
                    />
                )}
            </Page>

            <ModalConfirm
                show={isDirtyStateWarningModalOpen}
                type="default"
                onClose={() => setIsDirtyStateWarningModalOpen(false)}
                onConfirm={() => {
                    setTabs(
                        tabs.map((it) => {
                            it.current = it.resource === tabClicked;
                            return it
                        })
                    );
                    setIsDirtyStateWarningModalOpen(false);
                    setIsTabDirty(false);
                }}
                closeButtonLabel={translate("btn.stay_on_current_tab")}
                buttonLabel={translate("text.Continue")}
                title={translate('dialog_heading.unsaved_changes_on_tab')}
                translate={translate}
            >
                <p className="text-base">{translate('text.changes_on_tab')}</p>
                <p className="text-base">{translate('text.changes_will_be_lost')}</p>
            </ModalConfirm>
        </Layout>
    )
}

const getTabs = () => {
    return [
        {
            name: 'GeneralSettings',
            resource: Resources.CompanyGeneralSettings,
            current: true,
            visible: checkPerm(Resources.CompanyGeneralSettings, READ_PERM)
        },
        {
            name: 'customFields',
            resource: Resources.Lookup,
            current: false,
            visible: checkPerm(Resources.Lookup, READ_PERM)
        },
        {
            name: 'DocumentTypes',
            resource: Resources.DocumentTypes,
            current: false,
            visible: checkPerm(Resources.DocumentTypes, READ_PERM)
        },
        {
            name: 'RequiredDocuments',
            resource: Resources.DocumentEntities,
            current: false,
            visible: checkPerm(Resources.DocumentEntities, READ_PERM)
        },
        {
            name: 'ChecklistTemplate',
            resource: Resources.CustomersChecklistTemplate,
            current: false,
            visible: checkPerm(Resources.CustomersChecklistTemplate, READ_PERM)
        }
    ]
}
